<script>
	import { page } from '$app/stores';
</script>

{#if $page.status < 400}
	<script data-collect-dnt="true" async defer src="https://tales-of-landor.com/improve.js"></script>
	<noscript><img src="https://tales-of-landor.com/improve/noscript.gif?collect-dnt=true" alt="" referrerpolicy="no-referrer-when-downgrade" /></noscript>
{/if}
